import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { hideMessage, showAuthLoader, userSignIn, signInWithToken } from 'actions/Auth';
import CircularProgress from 'components/CircularProgress';
import Moment from 'moment';
class SignIn extends React.Component {
    constructor() {
        super();
        this.state = {
            email: '',
            password: ''
        };
    }

    componentDidMount() {
        this.emailInput.focus();
        if (this.props.authUser && this.props.tokenExpireTime && Moment().diff(this.props.tokenExpireTime) < 0) {
            this.props.signInWithToken(this.props.authUser);
        }
    }

    componentDidUpdate() {
        if (this.props.authUser !== null && this.props.tokenExpireTime && Moment().diff(this.props.tokenExpireTime) < 0) {
            this.props.history.push('/');
        }
    }

    render() {
        const { email, password } = this.state;
        const { showMessage, loader, alertMessage } = this.props;
        return (
            <div className="app-login-container d-flex justify-content-center align-items-center">
                <div className="app-login-main-content">
                    <div className="app-logo-content d-flex align-items-center justify-content-center">
                        <Link className="logo-lg" to="/" title="Jambo">
                            <img src="assets/images/Logo.svg" width={177} className="bg-white p-2" />
                        </Link>
                    </div>

                    <div className="app-login-content">
                        <div className="app-login-header mb-4">
                            <h1>Login</h1>
                        </div>

                        <div className="app-login-form">
                            <form>
                                <div className="form-group mb-3">
                                    <input
                                        ref={input => {
                                            this.emailInput = input;
                                        }}
                                        placeholder="Email"
                                        onChange={event => this.setState({ email: event.target.value })}
                                        defaultValue={email}
                                        className="form-control form-control-lg"
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <input
                                        type="password"
                                        placeholder="Passwort"
                                        onChange={event => this.setState({ password: event.target.value })}
                                        defaultValue={password}
                                        className="form-control form-control-lg"
                                    />
                                </div>

                                <div className="mb-3 d-flex align-items-center justify-content-between">
                                    <Button
                                        onClick={() => this.props.userSignIn({ email, password })}
                                        color="primary"
                                        className="text-uppercase bg-blue"
                                    >
                                        Anmelden
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ auth }) => {
    const { loader, alertMessage, showMessage, authUser, tokenExpireTime } = auth;
    return { loader, alertMessage, showMessage, authUser, tokenExpireTime };
};

export default connect(
    mapStateToProps,
    {
        userSignIn,
        hideMessage,
        showAuthLoader,
        signInWithToken
    }
)(SignIn);



// WEBPACK FOOTER //
// ./containers/SignIn.js